export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Votre commande a été vue',
    order_confirmed: '#{{number}} Heure confirmée {{time}}',
    order_preparation_up_time_changed: '#{{number}} Heure de {{type}} modifiée à {{time}}',
    order_preparing: 'Votre commande #{{number}} est en cours de préparation',
    order_rejected: 'Commande #{{number}} refusée',
  },
  order_type: {
    pickup: 'À emporter',
    delivery: 'Livraison',
  },
};
